import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectPaymentMethodById } from '../../../../../selectors/paymentMethods';
import { MethodWrapperContainer } from '../MethodWrapper';
import { CommonMethod } from './CommonMethod';
import { Icon } from './components/Icon';

interface IProps {
  id: string;
}

export const CommonMethodContainer = (props: IProps) => {
  const { id } = props;

  const { name, type } = useSelector(selectPaymentMethodById(id));

  return (
    <MethodWrapperContainer id={id}>
      <CommonMethod icon={<Icon type={type} />} name={name} />
    </MethodWrapperContainer>
  );
};
